import { Link } from 'wouter';
import { usePageMeta } from '../lib/seo';

/**
 * 404. Baseline C-7: production returned HTTP 200 for every unknown route with a
 * client-rendered 404 page — a soft-404, so search engines indexed every typo.
 *
 * The status code itself is fixed at the edge (nginx serves a real 404 for
 * unmatched non-asset paths — see infra/nginx). This component additionally
 * emits noindex so that any route that does reach the SPA is not indexed.
 */
export function NotFound() {
  usePageMeta({
    title: 'Page not found',
    description: 'The page you are looking for does not exist.',
    path: '/404',
  });

  return (
    <section className="section bg-white">
      <div className="container-content py-24 text-center">
        <p className="font-heading text-6xl font-bold text-navy">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-navy">Page not found.</h1>
        <p className="mx-auto mt-4 max-w-md text-charcoal/80">
          The page you are looking for may have moved. Try the catalogue, or send us your
          requirements and we will quote directly.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link href="/" className="btn btn-navy btn-hero">Return Home</Link>
          <Link href="/quote" className="btn btn-primary btn-hero">Request a Quote</Link>
        </div>
      </div>
    </section>
  );
}
